<script setup lang="ts">
import { computed, watch, onMounted } from 'vue';

import useContext from '@/composables/useContext';
import { setCategoryMeta } from '@/composables/useMeta';
import useGiftCard from '@/composables/useGiftCard';
import useGiftProductListing from '@/composables/useGiftProductListing';

import GiftCategoryMedia from '@/components/plp/CategoryMedia.vue';
import GiftProductListing from '@/components/plp/GiftListing.vue';

const { page, cart, navigate, channel } = useContext();
const { activeGiftCard } = useGiftCard();
const { singleSection } = useGiftProductListing();

const blocks = computed(() => {
  return page.value?.blocks?.Main || [];
});

const giftCard = computed(() => {
  const giftCards = activeGiftCard.value?.giftCards || [];
  return giftCards.length > 0 ? giftCards[0] : null;
});

const isSingleSection = computed(() => singleSection?.value);

const isTestAssortment = computed(() => {
  return page.value?.dataJson?.dataJson?.category?.fields?.TestAssortment;
});

onMounted(() => {
  setCategoryMeta();
  watch(
    () => cart.value,
    async () => {
      if (
        !isTestAssortment.value &&
        !giftCard.value &&
        cart.value?.currency?.id
      ) {
        await navigate(channel.value.rootPath);
      }
    },
    {
      immediate: true
    }
  );
});
</script>

<template>
  <div class="category">
    <div class="gifts-category__content">
      <GiftCategoryMedia />
      <blocks-repeater :blocks="blocks" class="gifts-category__blocks" />
      <GiftProductListing
        :displayLinks="
          isSingleSection !== undefined && isSingleSection === false
        "
      />
    </div>
  </div>
</template>

<style>
.category {
  display: flex;
  justify-content: center;
}

.gifts-category__content {
  width: 100%;

  @media (--tabletAndDesktop) {
    margin: 0 1rem 1rem;
  }
}

.gifts-category__blocks {
  margin: 0 auto;
  max-width: var(--site-max-width);
}
</style>
